import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {authenticationService} from "../../services";

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
        authenticationService.currentUserValue
            ? <Component {...props} />
            : <Redirect to='/login' />
    )} />
)

export default PrivateRoute;